import React from "react";
import { Link } from "react-router-dom";
import Door from "@/components/gateway2/Door";
import "@/enterprise-2.css";
import "@/enterprise-2-apple.css";
import "@/gateway-2.css";

// Gateway 2: Apple-inspired porcelain edition of the two-door gateway.
export default function Gateway2() {
  return (
    <div data-testid="gateway-2-root" className="gw2">
      <header className="gw2-nav">
        <div className="gw2-nav-inner">
          <Link to="/gateway-2" data-testid="gateway-2-brand" className="gw2-brand" aria-label="Crowther">
            <img src="/brand/gateway/crowther-full-forest.webp" alt="Crowther" className="gw2-brand-logo" />
          </Link>
          <div className="gw2-campaign" data-testid="gateway-2-campaign" aria-label="AI for Humans">
            <span>AI for Humans</span>
            <svg className="gw2-campaign-heart" width="13" height="12" viewBox="0 0 24 22" aria-hidden>
              <path d="M12 21s-9-5.5-9-12.5C3 4.4 6.4 2 9.5 2c1.9 0 3.6.9 4.5 2.3C14.9 2.9 16.6 2 18.5 2 21.6 2 25 4.4 25 8.5 25 15.5 12 21 12 21z" transform="translate(-1,0)" fill="#E63946" />
            </svg>
          </div>
          <span className="gw2-nav-spacer" aria-hidden />
        </div>
      </header>

      <main className="gw2-stage">
        <section className="gw2-doors">
          <Door
            side="left"
            index="01"
            tag="For People & Enterprises"
            title="Enterprises"
            lines={["AI shouldn\u2019t replace you.", "It should be built for you."]}
            headline="We are bringing intelligence to a billion people and enterprises."
            sub="Specialized intelligence built for your world."
            artPhoto="/brand/gateway/gw2-tower-photo.webp"
            artGlass="/brand/gateway/gw2-tower-glass.webp"
            to="/enterprise-2"
            cta="Discover our work for enterprises"
            delay={80}
          />
          <Door
            side="right"
            index="02"
            tag="For Machines"
            title="Machines"
            lines={["Machines already support you.", "We make them work better for you."]}
            headline="We are bringing intelligence to a billion machines."
            sub="Physical AI for the machines that move your world."
            artPhoto="/brand/gateway/gw2-robot-photo.webp"
            artGlass="/brand/gateway/gw2-robot-glass.webp"
            to="/machines-2"
            cta="Discover our work for machines"
            delay={200}
          />
        </section>
      </main>

      <footer className="gw2-foot">
        <span data-testid="gateway-2-footline-left">Human insight</span>
        <span className="gw2-foot-dot" aria-hidden />
        <span data-testid="gateway-2-footline-right">Amplified.</span>
      </footer>
    </div>
  );
}
